// extracted by mini-css-extract-plugin
export default {"container":"ns-z","heading":"os-z","text":"ps-z","info":"qs-z","link":"rs-z","fullMaxWidth":"ss-z"};